<template>
	<div class="fs tooltip is-tooltip-left" :data-tooltip="tooltip" @click="fullscreen()">
		<fs-icon/>
	</div>
</template>

<script>
import FsIcon from './icons/plein_ecran.svg'
import tooltips from '@texts/tooltips.json'

export default {
	name: 'Fullscreen',
	components: {
		FsIcon,
	},
	data() {
		return {
			tooltip: tooltips.fullscreen
		}
	},
	methods: {
		fullscreen() {
			let elm = document.documentElement

			if (elm.requestFullscreen) {
				elm.requestFullscreen()
			}
			else if (elm.mozRequestFullScreen) {
				elm.mozRequestFullScreen()
			}
			else if (elm.webkitRequestFullScreen) {
				elm.webkitRequestFullScreen()
			}
		}
	}

}
</script>


<style scoped lang="scss">

.fs {
	@extend %base-btn;

	background-color: #fff;
	width: 34px;
	height: 34px;
	padding: 8px;
	margin: 8px 6px;

	svg {
		max-width: 17px;
		> * {
			fill: $noir;
		}
	}

}

</style>
